import { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import TypeProductService from "../../../services/typeProductService";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
    md: {
      span: 9,
    },
    lg: {
      span: 10,
    },
    xl: {
      span: 10,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
    md: {
      span: 15,
    },
    lg: {
      span: 14,
    },
    xl: {
      span: 14,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
export default function TypeProductsModalForm({
  isModalVisible,
  handleOk,
  handleCancel,
  typeProductTarget = null,
}) {
  const [form] = Form.useForm();
  const [formField, setformField] = useState(null);

  useEffect(() => {
    if (typeProductTarget) {
      setformField([{ name: ["name"], value: typeProductTarget.name }]);
    }
  }, [typeProductTarget]);

  const onFinish = (values) => {
    let typeProductR = { ...values };
    if (typeProductTarget) {
      typeProductR.id = typeProductTarget.id;
      TypeProductService.updateTypeProduct(typeProductR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Tipo de producto actualizado.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo actualizar el Tipo de producto . " +
                res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message, 5);
        });
    } else {
      TypeProductService.createTypeproduct(typeProductR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Tipo de producto registrado.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo registar el Tipo de producto . " +
                res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message);
        });
    }
  };
  return (
    <Modal
      title="Registrar Tipo de Producto"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      footer={null}
    >
      <Form
        className="form"
        {...formItemLayout}
        form={form}
        fields={formField}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
      >
        <Form.Item
          name="name"
          label="Nombre del tipo de producto"
          rules={[
            {
              required: true,
              message: "Por favor ingresa el tipo de producto.",
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            Aceptar
          </Button>
          <Button
            type="secondary"
            htmlType="button"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancelar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
